import { styled } from "@mui/material/styles"
import { Box, DialogContent, Card, Typography } from "@mui/material"

export const UploadZone = styled(Box)(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  border: "2px dashed #CCC",
  cursor: "pointer",
  padding: 24,
  flex: 1,
  flexDirection: "column",
  justifyContent: "center",
}))

export const SpaceBetweenBoxWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  flex: 1,
  width: "100%",
}))

export const DialogContentWrapper = styled(DialogContent)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  minHeight: 500,
  padding: 0,
}))

export const UploadZoneWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  padding: 16,
}))

export const TypographyAlignRight = styled(Typography)(({ theme }) => ({
  display: "flex",
  flex: 1,
  justifyContent: "flex-end",
}))
